import { Link } from "../lib/router";
import { blogArticles } from "../lib/blog";

export function Blog() {
  return (
    <section className="py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center max-w-3xl mx-auto">
        <span className="inline-block px-3 py-1 rounded-full bg-orange-50 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 text-xs font-semibold border border-orange-200/60 dark:border-orange-500/20 mb-6">
          Blog
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold text-stone-900 dark:text-white tracking-tight mb-4">
          SocialCast Blog
        </h1>
        <p className="text-lg text-stone-500 dark:text-zinc-400 max-w-xl mx-auto leading-relaxed">
          Product updates, platform notes, and implementation guides for social publishing APIs.
        </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            href="/compare/ayrshare"
            className="block rounded-2xl border border-orange-200/70 dark:border-orange-500/30 bg-orange-50/60 dark:bg-orange-500/10 p-6 hover:shadow-lg hover:-translate-y-1 transition-all"
          >
            <div className="text-[11px] font-semibold uppercase text-orange-600 dark:text-orange-400 mb-4">Product comparison</div>
            <h2 className="text-xl font-bold text-stone-900 dark:text-white tracking-tight mb-3">SocialCast vs Ayrshare</h2>
            <p className="text-sm text-stone-500 dark:text-zinc-400 leading-relaxed mb-5">
              A sourced comparison of API scope, network coverage, product experience, account limits, and pricing.
            </p>
            <span className="text-xs text-orange-600 dark:text-orange-400 font-semibold">View comparison</span>
          </Link>
          {blogArticles.map((article) => (
            <Link
              key={article.slug}
              href={article.path}
              className="block rounded-2xl border border-stone-200/60 dark:border-zinc-800/60 bg-white dark:bg-zinc-900 p-6 hover:shadow-lg hover:-translate-y-1 transition-all"
            >
              <div className="flex items-center gap-2 text-[11px] font-semibold uppercase text-orange-600 dark:text-orange-400 mb-4">
                <span>{article.primaryKeyword}</span>
                <span className="text-stone-300 dark:text-zinc-700">/</span>
                <span>Vol {article.volume}</span>
              </div>
              <h2 className="text-xl font-bold text-stone-900 dark:text-white tracking-tight mb-3">
                {article.title}
              </h2>
              <p className="text-sm text-stone-500 dark:text-zinc-400 leading-relaxed mb-5">
                {article.description}
              </p>
              <div className="flex items-center justify-between text-xs text-stone-400 dark:text-zinc-500">
                <span>{article.readTime}</span>
                <span>{article.updated}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
